var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiltedArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8787 1.30787C12.8787 0.791167 12.4598 0.3723 11.9431 0.372299L3.52301 0.372299C3.00631 0.3723 2.58744 0.791167 2.58744 1.30787C2.58744 1.82457 3.00631 2.24343 3.52301 2.24343H11.0075V9.72797C11.0075 10.2447 11.4264 10.6635 11.9431 10.6635C12.4598 10.6635 12.8787 10.2447 12.8787 9.72797L12.8787 1.30787ZM2.31194 12.2621L12.6047 1.96941L11.2816 0.646321L0.988845 10.939L2.31194 12.2621Z",
    fill: "#FEFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiltedArrowIcon);
export default __webpack_public_path__ + "static/media/tilted-arrow-icon.381ac429f1d8deb2c7060a4df085c948.svg";
export { ForwardRef as ReactComponent };